import { render, staticRenderFns } from "./emailConfirmationDialog.vue?vue&type=template&id=de8d4644&scoped=true"
import script from "./emailConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./emailConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./emailConfirmationDialog.vue?vue&type=style&index=0&id=de8d4644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8d4644",
  null
  
)

export default component.exports